import { Skeleton } from 'antd';
import React from 'react';

export default function LineChartSkeleton({ title }) {
  return (
    <div className="bg-white border border-brand-inkGrey_grey_7 rounded-xl overflow-hidden hover:shadow cursor-pointer">
      <div className="w-full p-md border-b border-brand-inkGrey_grey_7">
        <div className="flex justify-between gap-4 items-start">
          <h6 className="mini semibold">{title}</h6>
        </div>
      </div>
      <div className="p-md">
        <Skeleton active />
      </div>
    </div>
  );
}
